/** Task keys and metric names arrive as snake_case; labels read better without the underscores. */
export const readable = (name: string) => name.split('_').join(' ');

export const sentenceCase = (name: string) => {
  const words = readable(name);
  return words.charAt(0).toUpperCase() + words.slice(1);
};

/**
 * Every metric any candidate reported, ranking metric first.
 *
 * The union rather than the first row's keys: a candidate whose scoring failed carries only counts,
 * and taking columns from whichever happened to be first either hid every real metric or left the
 * rest of the table blank.
 */
export const orderMetricNames = (
  results: { metrics: Record<string, unknown> }[],
  rankMetric: string | null,
) => {
  const names = [...new Set(results.flatMap(result => Object.keys(result.metrics)))];
  return names.sort(
    (a, b) => Number(a !== rankMetric) - Number(b !== rankMetric) || a.localeCompare(b),
  );
};
